<template>
  <b-modal
    ref="bModal"
    :title="$tc('grossing.modal.grossingResponsible', 2)"
    centered
    modal-class="grossingResponsiblesModal"
  >
    <b-row class="px-2">
      <b-col class="py-3">
        <b-row>
          <b-col>
            <div class="form-label">
              <label>{{ $tc('grossing.modal.grossingResponsible', 1) }}
              </label>
            </div>
          </b-col>
          <b-col cols="4">
            <div class="form-label">
              <label>{{ $t('grossing.sidebar.grossingDate') }}
              </label>
            </div>
          </b-col>
        </b-row>
        <div class="scrollable-area">
          <b-row
            v-for="grossingElement in grossingResponsibles"
            :key="grossingElement.sgdId"
            class="responsible-row py-2"
          >
            <b-col>
              <div>
                <span>{{ grossingElement.responsibleForGrossing.fullName }}</span>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <span>{{ grossingElement.grossingDate | datetime }}</span>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-12 text-right">
          <b-button
            size="sm"
            variant="outline-primary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.close') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import grossingSampleService from '@/modules/grossingModule/services/grossingSampleService'

export default {
    name: 'GrossingResponsibleListModal',
    props: {
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true },
        sampleId: { type: Number, required: true }
    },
    data() {
        return {
            grossingResponsibles: []
        }
    },
    methods: {
        async show() {
            await this.loadGrossingHistory()
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        async loadGrossingHistory() {
            const [error, response] = await this.toCall(grossingSampleService.getGrossingDatesHistory(this.laboratoryId, this.caseId, this.sampleId))

            if (error) {
                this.showErrorModalGlobal()
                return
            }
            this.grossingResponsibles = response
        }
    }
}
</script>

<style lang="scss">

    .grossingResponsiblesModal .modal-dialog {
        max-width: 40%;
    }

    .grossingResponsiblesModal .modal-body {
        padding: 0.6rem 1.1rem 0 1.1rem !important;
    }

    .grossingResponsiblesModal .responsible-row {
        border-bottom: 1px solid vt-color(general-border);
        color: vt-color(dark-text);
    }

    .grossingResponsiblesModal .scrollable-area {
        min-height: calc(60vh - 380px);
        max-height: calc(60vh - 320px);
        overflow-y: auto;
        overflow-x: hidden;
    }

</style>
